import { hotKeywords } from "@/mocks/homeData";

const trendMeta: Record<string, { icon: string; color: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-600", label: "升温" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600", label: "降温" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-500", label: "持平" },
};

export default function HotKeywordIndex() {
  return (
    <section id="hot-words" className="w-full border-b border-background-200/70 bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium text-primary-600 md:text-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-price-tag-3-line text-base" aria-hidden="true"></i>
              </span>
              模块 01 · 热点词索引
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              热点词索引表
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每个词都是一条索引入口，点击即可进入该关键词对应的条目集合，查看人物、事件与出处分布。
            </p>
          </div>
          <a
            href="#rank"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看完整热度榜
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {hotKeywords.map((item, index) => {
            const meta = trendMeta[item.trend] ?? trendMeta.flat;
            return (
              <a
                key={item.keyword}
                href="#zones"
                style={{ animationDelay: `${index * 40}ms` }}
                className="animate-fade-up group flex items-center justify-between gap-3 rounded-lg border border-background-200/80 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-300 md:px-5 md:py-4"
              >
                <div className="min-w-0">
                  <p className="flex items-center gap-2 text-sm font-semibold text-foreground-950 md:text-base">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 font-heading text-xs text-primary-700">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    {item.keyword}
                  </p>
                  <p className="mt-1 truncate text-xs text-foreground-500 md:text-sm">{item.note}</p>
                </div>
                <div className="shrink-0 text-right">
                  <p className="text-sm font-semibold text-foreground-900 md:text-base">{item.count}</p>
                  <p className={`mt-0.5 flex items-center justify-end gap-0.5 text-xs ${meta.color}`}>
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className={meta.icon} aria-hidden="true"></i>
                    </span>
                    {meta.label}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}